import { useEffect, useState } from "react";
import { VideoService } from "src/services/videoCallService";
import { renderErrors } from "src/helper/error-message-helper";
import { NotificationManager } from "react-notifications";
import { Dialog } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { GetClientContactInformation, GetClientContactInformationByEvent, SendTelehealthLinkToProvidedContact } from "src/redux/actions";
import { TableRowsLoader } from "../custom-skelton";
import PhoneInputMask from "../../control-components/phone-input-mask/phone-input-mask"
import InputKendoRct from "../input/input";
import { Error } from "@progress/kendo-react-labels";

function SendLink({ roomName, clientDetails ,eventId}) {
    const [isSend, setIsSend] = useState(false);
    const [isOpenTelehealthLinkSendDialog, setIsOpenTelehealthLinkSendDialog] = useState(false);
    const [loading, setLoading] = useState(true);
    const [fields, setFields] = useState(null);
    const [isButtonPressed, setButtonPressed] = useState(false);
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    //GLOBAL STATES
    const state = useSelector((states) => states);
    const { clientContactInformationByEvent, clientContactInformation } = state['ClientReducer'];

    //hooks
    const dispatch = useDispatch()

    useEffect(() => {
        if(clientContactInformation) {
            setLoading(false)
            setFields(clientContactInformation)
        }
    }, [clientContactInformation])

    useEffect(() => {
        if(clientContactInformationByEvent) {
            setLoading(false)
            setFields(clientContactInformationByEvent)
        }
    }, [clientContactInformationByEvent])

    // onClick handler function for the Send button
    const handleSendLink = async () => {
        // Asynchronously call SendLink
        await VideoService.sendLinkService(roomName, clientDetails)
            .then((result) => {
                NotificationManager.success(`Telehealth meeting link sent to ${clientDetails?.fName} ${clientDetails?.lName} successfully`);

                setIsSend(true);
                setTimeout(() => {
                    setIsSend(false);
                }, 1000);
            })
            .catch((err) => {
                renderErrors(err);

            });
    }

    const handleSendLinkUsingEvent = async () => {
        // Asynchronously call SendLink
        await VideoService.sendLinkServiceByEventId(roomName, eventId)
            .then((result) => {
                NotificationManager.success(`Telehealth meeting link has been sent successfully`);
                setIsSend(true);
                setTimeout(() => {
                    setIsSend(false);
                }, 1000);
            })
            .catch((err) => {
                renderErrors(err);

            });
    }    

    function handleSendLinkParent() {
        if (!Array.isArray(fields) || fields.length === 0) {
            return;
        }    
        const hasInvalidRecord = fields.some(({ email, phone }) => {
            const cleanedPhone = phone?.replace(/[^0-9]/g, '');
            return (
                !email ||
                !phone ||
                cleanedPhone.length < 10 ||
                !emailPattern.test(email)
            );
        });
    
        if (hasInvalidRecord) {
            setButtonPressed(true)
            return;
        }
        else {
            setButtonPressed(false)
        }
    
        const filteredFields = fields.map(({ clientId, ...rest }) => rest);

        const data = {
            roomId: roomName,
            contactsList: filteredFields,
        };
    
        dispatch(SendTelehealthLinkToProvidedContact(data));
        handleSwitchShowDialog(false);
    }

    function handleSwitchShowDialog(isOpen) {
        if(isOpen) {
            if(clientDetails) {
                const data = {
                    clientIds: [clientDetails?.id]
                }
                dispatch(GetClientContactInformation(data));
            }
            else {
                const data = {
                    eventId
                }
                dispatch(GetClientContactInformationByEvent(data));
            }
            setLoading(true);
        }
        setIsOpenTelehealthLinkSendDialog(!isOpenTelehealthLinkSendDialog);
        setButtonPressed(false);
    }

    const handleChange = (e, currentClientId) => {
        const name = e.target.name;
        const rawValue = e.target.value;
      
        setFields((prevFields) =>
          prevFields.map((item) =>
            item.clientId === currentClientId
              ? { ...item, [name]: rawValue }
              : item
          )
        );
    };
      

    return (
        <div>
            {/* Bind our handler function to the onClick button property */}
            <button className="copy-mainbtn mr-1" onClick={() => handleSwitchShowDialog(true)} >
            <i className="fa fa-paper-plane " style={{ color: "white", marginRight: "5px" }}></i>  {isSend ? 'Sent' : 'Send Meeting Link'}
                
            </button>

            {isOpenTelehealthLinkSendDialog && 
                <Dialog
                    onClose={() => handleSwitchShowDialog(false)}
                    title={'Send Telehealth Link'}
                    className="pagination-row-cus blue_theme"
                    width={"50%"}
                    height={"50%"}>
                    <div className="grid-table table-heading-auth mt-2">
                        <div>
                            {loading ?
                                <TableRowsLoader rowsNum={5}/>
                            :
                                    fields.map((item) => {
                                        let currentClient = '';
                                        if(clientDetails) {
                                            currentClient = fields?.find((item1) => item1?.clientId === item?.clientId);
                                        }
                                        else {
                                            currentClient = fields?.find((item1) => item1?.clientId === item?.clientId);
                                        }
                                        return (<> <div className="row">
                                            <div className="col-md-3">
                                                <label>Client</label>
                                                <div className="pt-2">{item?.lName}, {item?.fName}</div>
                                            </div>

                                            <div className="col-md-4">
                                                <PhoneInputMask
                                                  value={currentClient?.phone}
                                                  onChange={(e) => handleChange(e, currentClient?.clientId)}
                                                  name="phone"
                                                  label="Mobile"
                                                  validityStyles={false}
                                                  placeholder=""
                                                  maskValidation={false}
                                                  disabled={false}
                                                  error={""}
                                                  required={false}
                                                />
                                                {isButtonPressed && (currentClient?.phone === "(___) ___-____" || !currentClient?.phone) && 
                                                    (<Error>{'* Field is required'}</Error>
                                                )}                                                
                                                {(isButtonPressed && ((currentClient?.phone !== "(___) ___-____") && currentClient?.phone) && parseInt(currentClient?.phone.replace(/[^0-9]/g, ''), 10).toString().length<10) && 
                                                <Error>{'* Please enter a valid phone number'}</Error>}
                                            </div>
                                            <div className="col-md-4">
                                                <InputKendoRct
                                                  validityStyles={false}
                                                  value={currentClient?.email}
                                                  onChange={(e) => handleChange(e, currentClient?.clientId)}
                                                  name="email"
                                                  label="Email"
                                                //   error={!fields.email && errors.email}
                                                  minLength={0}
                                                  maxLength={255}
                                                  type=""
                                                  disabled={false}
                                                  focusout={() => { }}
                                                  placeholder=""
                                                  pattern=""
                                                  width=""
                                                  min={0}
                                                  format=""
                                                  required={false}
                                                />
                                                {(isButtonPressed && !currentClient?.email) && <Error className="mt-3">{'* Field is required'}</Error>}
                                                {(isButtonPressed && currentClient?.email && !emailPattern.test(currentClient.email)) && <Error className="mt-3">{'* Enter a valid email'}</Error>}
                                            </div>
                                            {fields.length > 0 && <div style={{alignContent: 'center'}} className="pt-3 col-md-1"><i
                                                onClick={() => {
                                                    if(clientDetails) {
                                                        if(fields?.length < 2) {
                                                            NotificationManager.error('Atleast One Client is Required!');
                                                            return ;
                                                        }
                                                        setFields(fields?.filter(item => item.clientId !== currentClient.clientId));
                                                    }
                                                    else {
                                                        if(fields?.length < 2) {
                                                            NotificationManager.error('Atleast One Client is Required!');
                                                            return ;
                                                        }
                                                        setFields(fields?.filter(item => item.clientId !== currentClient.clientId));
                                                    }
                                                }}
                                                className="fa-solid fa-xmark cross-red"></i></div>
                                            }
                                        </div>
                                        </>
                                    )
                                    }) 
                                    
                          }
                    </div>
                </div>
                    <div className="">
                        <div className="border-bottom-line"></div>
                        <div className="d-flex my-3 px-4 mx-2" >
                            <div>
                                <button className='submitButon px-4' disabled={fields?.length <= 0} onClick={handleSendLinkParent}>
                                    Submit
                                </button>
                            </div>
                            <div>
                                <button className='cancelBtn' onClick={() => handleSwitchShowDialog(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </Dialog>
            }
        </div>
    );
}

export default SendLink